export default "__VITE_ASSET__6eadf409__"